var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgLinebreak = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "-3 -3 21 21" }, props, { children: _jsxs("g", __assign({ fill: "#008dcb" }, { children: [_jsx("path", { "data-name": "Path 87", d: "M.82 10.751 0 15.674a.28.28 0 0 0 .078.244.281.281 0 0 0 .249.082l4.91-.83a.281.281 0 0 0 .151-.475l-.96-.96 2.577-2.577a.28.28 0 0 0 0-.4L5.229 8.981a.28.28 0 0 0-.4 0l-2.573 2.578L1.3 10.6a.28.28 0 0 0-.475.153Z" }), _jsx("path", { "data-name": "Path 88", d: "M15.18 5.249 16 .326a.28.28 0 0 0-.078-.244.282.282 0 0 0-.249-.082l-4.91.83a.281.281 0 0 0-.151.475l.96.96-2.578 2.581a.28.28 0 0 0 0 .4l1.776 1.776a.28.28 0 0 0 .4 0l2.577-2.577.96.96a.28.28 0 0 0 .475-.153Z" })] })) }))); };
export default SvgLinebreak;
